const Logo = () => {
    return <div className="logo"></div>;
};

export default Logo;
